var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

/* eslint-disable jsdoc/require-param */
import { Component, Prop, CustomElement, Event, nothing, html } from '@sick-davinci/ce-decorators';
import { style } from './StatusTile.style';
import { IconRef } from '@sick-davinci/basic-elements';
import { icon_chevron_right } from '@sick-davinci/material-icons/navigation/chevron_right.icon.js';
import { icon_settings } from '@sick-davinci/material-icons/action/settings.icon.js';
import { icon_warning } from '@sick-davinci/material-icons/alert/warning.icon.js';
import { icon_error } from '@sick-davinci/material-icons/alert/error.icon.js';
import { icon_check_circle } from '@sick-davinci/material-icons/action/check_circle.icon.js';
import { icon_help } from '@sick-davinci/material-icons/action/help.icon.js';
/**
 * Displays a status containing a symbol and a one-line text beneath.
 *
 * @example
 * ```
 *   <davinci-status-tile status="warning" heading="Warning" header-icon="next" text="Warning" style="width: 300px; height: 300px;"></davinci-status-tile>
 * ```
 * @slot { * } default - default slot, can consume any element
 */

export let StatusTile = (_dec = Component({
  tag: 'davinci-status-tile',
  style,
  dependencies: [IconRef]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", String), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", String), _dec12 = Event(), _dec13 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class StatusTile extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "headerIcon", _descriptor, this);

    _initializerDefineProperty(this, "symbol", _descriptor2, this);

    _initializerDefineProperty(this, "text", _descriptor3, this);

    _initializerDefineProperty(this, "heading", _descriptor4, this);

    _initializerDefineProperty(this, "status", _descriptor5, this);

    _initializerDefineProperty(this, "headerIconClicked", _descriptor6, this);
  }

  /**
   * See base class
   */
  render() {
    return html`
    <div id='parent'>
      <div id='header'>
        <div id='title'>${this.heading}</div>
        <div id='icon'>${this.headerIcon === 'none' ? nothing : this._renderIcon(this.headerIcon === 'next' ? icon_chevron_right : icon_settings, this._onHeaderIconClicked)}</div>
      </div>
      <div id='symbol'>
        ${this._renderIcon(this.symbol)}
      </div>
      <svg id='text' viewBox="0 0 248 50" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMin slice">
        <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%" >
          <p style="margin:0; text-align: center; white-space: nowrap; text-overflow: ellipsis; overflow: hidden">${this.text}</p>
        </foreignObject>
      </svg>
    </div>`;
  }

  _renderIcon(icon, onClick) {
    if (!icon) {
      icon = this._getDefaultIcon();
    }

    return html`
      <davinci-icon-ref
        .src="${icon}"
        @click="${onClick}"
      ></davinci-icon-ref>
    `;
  }

  _onHeaderIconClicked(_event) {
    this.headerIconClicked.emit();
  }

  _getDefaultIcon() {
    switch (this.status) {
      default:
      case 'unknown':
        return icon_help;

      case 'warning':
        return icon_warning;

      case 'error':
        return icon_error;

      case 'ok':
        return icon_check_circle;
    }
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "headerIcon", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'none';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "symbol", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "text", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "heading", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'Caption';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "status", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'default';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "headerIconClicked", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
